module.exports = __webpack_public_path__ + "media/images/illustrations/flat_fogg_success-cb29a443c5b2404f10be119381334a6f.png";